import React from "react";

import "css/cargando.css";
import LanguageHelper from 'helpers/language_helper';

export const Cargando =()=> {
  return (
    <div className="contenedor has-text-centered">
      <h1 className="is title is-3 m-t-50">¡ {LanguageHelper.getLanguageString('Load.message')} !</h1>
      <h1 className="is title is-1">{LanguageHelper.getLanguageString('Load.message1')}<b> {LanguageHelper.getLanguageString('Load.message2')}</b></h1>
      <div className="Cargando">
        <div className="circle one" />
        <div className="circle two" />
        <div className="circle three" />
      </div>
    </div>
  );
}

export const CargandoSmall =()=> {
  return (
      <div className="spinner"></div>
  );
}